if (!customElements.get('cart-item-addon')) {

  console.log("Custom Element");

  var CartItemAddon = class extends HTMLElement {

    connectedCallback() {

      console.log('CartItemAddon');

      this.expandButton.addEventListener("click", this.toggleExpand.bind(this));

    }

    // Expand / Collapse Logic

    toggleExpand() {

      if (expanded) {
        this.collapse();
      }
      else {
        this.expand();
      }

    }

    collapse() {
      this.classList.remove("addon--expanded");
    }

    expand() {
      this.classList.add("addon--expanded");
    }

    // Elements

    get expandButton() {
      return this.querySelector(`[data-expand-button]`);
    }

    get expanded() {
      return this.classList.contains("addon--expanded") ? true : false;
    }

    get productId() {

    }

  };
  window.customElements.define("cart-item-addon", CartItemAddon);

}